__turbopack_context__.v({
  "description": "CarouselEndContent-module__4D5xuq__description",
  "root": "CarouselEndContent-module__4D5xuq__root",
  "title": "CarouselEndContent-module__4D5xuq__title",
});
